"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _classnames = _interopRequireDefault(require("classnames"));

var _CSSTransitionGroup = _interopRequireDefault(require("react-transition-group/CSSTransitionGroup"));

var _globalClass = require("../util/globalClass");

var _keyCodes = require("../util/keyCodes");

var OPEN_CLASS = 'zsg-lightbox_scroll';
/**
 * Stores keys of the lightbox uniqueId's that are currently open.
 * Should only have 1 entry at a time.
 */

var openLightboxUniqueIds = {};
/**
 * Number of mounted lightboxes. Use to generate unique ids
 */

var numLightboxes = 0;

var Lightbox =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(Lightbox, _React$Component);

  function Lightbox(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Lightbox);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Lightbox).call(this, props));
    _this.uniqueId = Lightbox.numLightboxes++;
    _this.state = {
      portal: null
    };
    _this.onLightboxMouseDown = _this.onLightboxMouseDown.bind((0, _assertThisInitialized2["default"])((0, _assertThisInitialized2["default"])(_this)));
    _this.onLightboxClick = _this.onLightboxClick.bind((0, _assertThisInitialized2["default"])((0, _assertThisInitialized2["default"])(_this)));
    _this.keyDownListener = _this.onKeyDown.bind((0, _assertThisInitialized2["default"])((0, _assertThisInitialized2["default"])(_this)));
    _this.handleXClick = _this.handleXClick.bind((0, _assertThisInitialized2["default"])((0, _assertThisInitialized2["default"])(_this)));
    _this.wasYUILightboxActive = (0, _globalClass.hasGlobalClass)(OPEN_CLASS) && Object.keys(Lightbox.openLightboxUniqueIds).length === 0;
    return _this;
  }

  (0, _createClass2["default"])(Lightbox, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.preparePortal();

      if (!this.props.renderInline) {
        this.renderToBody(this.props);
      }

      document.addEventListener('keydown', this.keyDownListener);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (_reactDom["default"].unmountComponentAtNode(this.state.portal)) {
        document.body.removeChild(this.state.portal);
      } // no cleanup of state necessary
      // see https://github.com/facebook/react/issues/12111


      this.toggleClass(false);
      document.removeEventListener('keydown', this.keyDownListener);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(newProps) {
      if (!newProps.renderInline) {
        this.renderToBody(newProps);
      }
    }
  }, {
    key: "onKeyDown",
    value: function onKeyDown(e) {
      if (e.keyCode === _keyCodes.ESC_KEY && this.props.isOpen) {
        this.props.onClose(e);
      }
    }
  }, {
    key: "onLightboxMouseDown",
    value: function onLightboxMouseDown(e) {
      // Ignore next click handle if click began inside lightbox content
      this.ignoreNextClick = e.target !== e.currentTarget;
    }
  }, {
    key: "onLightboxClick",
    value: function onLightboxClick(e) {
      if (e.target === e.currentTarget && !this.ignoreNextClick) {
        this.props.onClose(e);
      }
    }
  }, {
    key: "handleXClick",
    value: function handleXClick(e) {
      e.stopPropagation();
      this.props.onClose(e);
    }
  }, {
    key: "getMarkup",
    value: function getMarkup(props) {
      var mask;
      var lightbox;
      var maskStyle = {
        display: 'block'
      };
      var contentStyle = {};

      if (props.width) {
        contentStyle.maxWidth = props.width;
      }

      if (props.animationType) {
        contentStyle.animationDuration = props.animationDuration + "ms";
        maskStyle.animationDuration = props.animationDuration + "ms";
      }

      if (props.isOpen) {
        mask = _react["default"].createElement("div", {
          className: (0, _classnames["default"])('yui3-lightbox-mask', props.maskClassName),
          style: maskStyle
        });
        lightbox = _react["default"].createElement("div", {
          id: props.id,
          className: (0, _classnames["default"])('yui3-lightbox', props.className),
          onMouseDown: this.onLightboxMouseDown,
          onClick: this.onLightboxClick,
          onScroll: props.onScroll
        }, _react["default"].createElement("div", {
          className: (0, _classnames["default"])('yui3-lightbox-content', {
            'lightbox_responsive': props.responsive
          }, props.animationType),
          style: contentStyle
        }, _react["default"].createElement("a", {
          className: "zsg-icon-x-thin lightbox-close",
          title: "Close",
          tabIndex: "-1",
          onClick: this.handleXClick
        }), _react["default"].createElement("div", {
          className: "lightbox-body zsg-tooltip-viewport"
        }, props.children)));
      }

      if (props.animationType) {
        return _react["default"].createElement(_CSSTransitionGroup["default"], {
          transitionName: "lightbox-transition",
          transitionEnterTimeout: props.animationDuration,
          transitionLeaveTimeout: props.animationDuration
        }, lightbox, mask);
      }

      return _react["default"].createElement("div", null, lightbox, mask);
    }
  }, {
    key: "preparePortal",
    value: function preparePortal() {
      var portal = document.createElement('div');
      document.body.appendChild(portal);
      this.setState({
        portal: portal
      });
    } // IE does not support classList.toggle with a boolean param

  }, {
    key: "toggleClass",
    value: function toggleClass(open) {
      if (open) {
        Lightbox.openLightboxUniqueIds[this.uniqueId] = open;
      } else {
        delete Lightbox.openLightboxUniqueIds[this.uniqueId];
      }

      if (Object.keys(Lightbox.openLightboxUniqueIds).length !== 0) {
        (0, _globalClass.addGlobalClass)(OPEN_CLASS);
      } else if (!this.wasYUILightboxActive) {
        (0, _globalClass.removeGlobalClass)(OPEN_CLASS);
      }
    }
  }, {
    key: "renderToBody",
    value: function renderToBody(props) {
      this.toggleClass(props.isOpen);

      if (this.state.portal && !_reactDom["default"].createPortal) {
        _reactDom["default"].unstable_renderSubtreeIntoContainer(this, this.getMarkup(props), this.state.portal);
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.props.renderInline) {
        if (this.state.portal && _reactDom["default"].createPortal) {
          return _reactDom["default"].createPortal(this.getMarkup(this.props), this.state.portal);
        }

        return null;
      }

      this.toggleClass(this.props.isOpen);
      return this.getMarkup(this.props);
    }
  }], [{
    key: "openLightboxUniqueIds",
    get: function get() {
      return openLightboxUniqueIds;
    }
  }, {
    key: "numLightboxes",
    get: function get() {
      return numLightboxes;
    },
    set: function set(val) {
      numLightboxes = val;
    }
  }]);
  return Lightbox;
}(_react["default"].Component);

Lightbox.defaultProps = {
  animationDuration: 300
};
Lightbox.propTypes = process.env.NODE_ENV !== "production" ? {
  id: _propTypes["default"].string,

  /**
   * Duration of animation in ms
   */
  animationDuration: _propTypes["default"].number,

  /**
   * Animation type, null will disable animations
   */
  animationType: _propTypes["default"].oneOf(['fade', 'slideUp', 'slideLeft', 'fadeAndSlideUp', 'fadeAndSlideLeft']),

  /**
   * additional classes to add to 'yui3-lightbox'
   */
  className: _propTypes["default"].string,
  isOpen: _propTypes["default"].bool,

  /**
   * additional classes to add to 'yui3-lightbox-mask'
   */
  maskClassName: _propTypes["default"].string,

  /**
   * called when user closes the lightbox with the 'X' or escape.
   */
  onClose: _propTypes["default"].func.isRequired,

  /**
   * called when scrolling the lightbox content
   */
  onScroll: _propTypes["default"].func,

  /**
   * renders the lightbox within context, instead of through a portal
   */
  renderInline: _propTypes["default"].bool,

  /**
   * Renders the lightbox fullscreen at viewport breakpoint `@zsgMediaM_lte`
   */
  responsive: _propTypes["default"].bool,

  /**
   * width of lightbox content
   */
  width: _propTypes["default"].string
} : {};
var _default = Lightbox;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@zillow/react-zsg/Lightbox/index.js
// module id = 490
// module chunks = 0